var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mt-3"},[_c('h4',{staticClass:"text-lg font-bold",domProps:{"innerHTML":_vm._s(_vm.currentTitle)}})])}
var staticRenderFns = []

export { render, staticRenderFns }